const home = () => import(/* webpackChunkName: "home" */ './pages/home');
const articleList = () => import(/* webpackChunkName: "articleList" */ './pages/articleList');
const articleDetail = () => import(/* webpackChunkName: "articleDetail" */ './pages/articleDetail');
const appCenter = () => import(/* webpackChunkName: "appCenter" */ './pages/appCenter');

export default [
    {
        path: '/webModulePage/home',
        name: 'Home',
        component: home,
        meta: {
            disableValidation: true,
        },
    },
    {
        path: '/webModulePage/articleList',
        name: 'ArticleList',
        component: articleList,
        meta: {
            disableValidation: true,
        },
    },
    {
        path: '/webModulePage/articleDetail',
        name: 'ArticleDetail',
        component: articleDetail,
        meta: {
            disableValidation: true,
        },
    },
    {
        path: '/webModulePage/appCenter',
        name: 'AppCenter',
        component: appCenter,
        meta: {
            disableValidation: true,
        },
    },
];
